import config from "@Config/index";
import axios from "axios";
import getUniAppHeaders from "helpers/getUniAppHeaders";

// eslint-disable-next-line import/prefer-default-export
export const submitBookForm = async (params: any) => {
  const controller = new AbortController();
  try {
    const { data } = await axios.post(
      `${config.API_URL}/api/v0/forms/`,
      {
        form: { ...params, source: "internal" },
        signal: controller.signal,
      },
      {
        headers: getUniAppHeaders(),
      },
    );
    return { ...data };
  } catch (error: any) {
    if (typeof window !== undefined && typeof window.Sentry !== "undefined") {
      window.Sentry.captureException(`BookForm api fail ->  ${error} `, {
        extra: { request: JSON.stringify(params), response: error },
      });
    }
    if (error?.message === "Network Error") controller.abort();
    return { error };
  }
};
// eslint-disable-next-line import/prefer-default-export
export const updateBookForm = async (formUUID: any, params: any) => {
  const controller = new AbortController();
  try {
    const { data } = await axios.put(`${config.API_URL}/api/v0/forms/${formUUID}`, {
      form: { ...params, source: "internal" },
      signal: controller.signal,
    });
    return { ...data };
  } catch (error: any) {
    if (typeof window !== undefined && typeof window.Sentry !== "undefined") {
      window.Sentry.captureException(`BookForm update api fail for ${formUUID} ->  ${error} `, {
        extra: { request: JSON.stringify(params), response: error },
      });
    }
    if (error?.message === "Network Error") controller.abort();
    return { error };
  }
};
